/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import { Breadcrumb, Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { usePageTitle } from '../../../../../App';
import check_yellow_icon from '../../../../../assets/images/check-yellow-icon.svg';
import star_icon from '../../../../../assets/images/red-star-icon.svg';
import { CustomTooltips } from '../../../../../components';
import { ALL_FILE_ROUTE } from '../../../../../constants/RouteNameConstants';
import { cgaFilesTableData } from '../../../../../constants/TableHeaderConstants';
import { truncateString } from '../../../../../utils/TruncateStringUtils';
import moment from 'moment';
import { getDaysDiff } from '../../AllFiles/component/AllFiles';
import { Badge } from '@mui/material';
import { trackEvent } from '../../../../../utils/ga';
import { cgaClientListRequest, cgaFilesRequest, updateCGAFileStates } from '../actions';
import { CGAFileType } from '../../../../../constants/CGATypes';
import CustomTreeTable from '../../../../../components/CustomTreeTable';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { CustomButton } from '../../../../../components/mui/CustomButton';
import ActionTemplate from './ActionTemplate';
import { MultiSelect } from 'primereact/multiselect';
import { CGAFileStatusOptions } from '../../../../../constants/SlectOptionConstants';

const CGAFiles = () => {
    usePageTitle('Datagain Transcription  - Files > CGA Files'); // Set tab title

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const debounceTimer = useRef(null);
    const [searchValue, setSearchValue] = useState('');
    const { cgaSearchValue, rowsPerPage, currentPage, filterClientData, filterFilesStatusData, isFilterApplied, sortField, sortOrder } = useSelector((state) => state.cgaFileStates);
    const [filterData, setFilterData] = useState({
        filterClientData: filterClientData,
        filterFilesStatusData: filterFilesStatusData,
    });
    const [proofReaderCGAFileFilterModal, setProofReaderCGAFileFilterModal] = useState(false);

    const handleCGAFileFilter = () => {
        trackEvent('file_filter', {
            page: 'cga_files',
            client: filterData.filterClientData,
            status: filterData.filterFilesStatusData,
        });
        dispatch(updateCGAFileStates({ filterClientData: filterData.filterClientData, filterFilesStatusData: filterData.filterFilesStatusData }));
        if(filterData.filterClientData !== '' || filterData.filterFilesStatusData.length > 0) {
            dispatch(updateCGAFileStates({ isFilterApplied: true }));
        } else {
            dispatch(updateCGAFileStates({ isFilterApplied: false }));
        }
        setProofReaderCGAFileFilterModal(false);
    };

    // My file's Data
    let cgaClientList = useSelector((state) => state?.cgaClientList?.user);

    let CGAFileList = useSelector((state) => state?.cgaFilesList?.user?.data?.value);
    let CGAFileLoading = useSelector((state) => state?.cgaFilesList?.loading);
    let CGAFileListTable = CGAFileList && JSON.parse(CGAFileList).Files;
    let CGAFileNoOfRecords = CGAFileList && JSON.parse(CGAFileList).NoOfRecords;

    const handleSearch = (event) => {
        const value = event.target.value;
        setSearchValue(value);

        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }

        debounceTimer.current = setTimeout(() => {
            dispatch(updateCGAFileStates({ cgaSearchValue: value, currentPage: 0 }));
            if (value)
                trackEvent('file_search', {
                    query: value,
                    page: 'cga_files',
                });
        }, 2000);
    };

    // Table data sorting function
    const handleSortChange = (event) => {
        dispatch(updateCGAFileStates({ sortField: event.sortField, sortOrder: event.sortOrder, currentPage: 0 }));
    };

    useEffect(() => {
        dispatch(
            cgaFilesRequest({
                page: currentPage + 1,
                rowNumber: rowsPerPage,
                sortRowName: sortField,
                sortRowDirection: sortOrder === 1 ? 'asc' : 'desc',
                search: cgaSearchValue,
                filter: isFilterApplied ?
                    {
                        status: filterFilesStatusData?.length > 0 ? filterFilesStatusData : undefined,
                        clientId: filterClientData ? filterClientData : undefined,
                    } : null
            }),
        );
    }, [dispatch, currentPage, rowsPerPage, sortField, sortOrder, cgaSearchValue, isFilterApplied, filterFilesStatusData, filterClientData]);

    useEffect(() => {
        dispatch(cgaClientListRequest());
    }, [dispatch]);

    useEffect(() => {
        if (!proofReaderCGAFileFilterModal) {
            setFilterData({ ...filterData, filterClientData: filterClientData, filterFilesStatusData: filterFilesStatusData });
        }
    }, [proofReaderCGAFileFilterModal, filterClientData, filterFilesStatusData])

    const handleShowProofReaderCGAFileFilter = () => {
        setProofReaderCGAFileFilterModal(true);
    };

    const handleCloseProofReaderCGAFileFilter = () => {
        setProofReaderCGAFileFilterModal(false);
    };

    const handleCGAFileFilterClear = () => {
        setFilterData({ filterClientData: '', filterFilesStatusData: [] });
        dispatch(updateCGAFileStates({ filterClientData: '', filterFilesStatusData: [], isFilterApplied: false }));
        setProofReaderCGAFileFilterModal(false);
    };

    // Custom body template for file name on column
    const CGAFileTemplate = (rowData, { isRowHovered, expandedRows, toggleRow }) => {
        const isExpanded = expandedRows?.some((row) => row === rowData?.Id);

        return (
            <div
                className="d-flex align-items-center gap-2"
                style={{ minWidth: '310px', whiteSpace: 'normal', wordBreak: 'break-word' }}
                onMouseDown={(e) => e.stopPropagation()}
            >
                <CustomButton
                    onClick={() => toggleRow(rowData.Id)}
                    size="icon"
                    variant="icon"
                    sx={{
                        visibility: rowData?.isChild ? 'hidden' : 'visible',
                    }}
                >
                    {isExpanded ? <ExpandMore fontSize="32px" /> : <ExpandLess fontSize="32px" style={{ transform: 'rotate(90deg)' }} />}
                </CustomButton>

                <div style={{
                    color: !rowData?.isChild ? 'black' : 'gray',
                }}>
                    <CustomTooltips title={rowData?.UserFileName} placement="bottom" className="cursor-auto">
                        <span
                            style={{
                                userSelect: 'text',
                            }}
                            title={rowData?.UserFileName}
                        >
                            {truncateString(rowData?.UserFileName, 25)}
                        </span>
                    </CustomTooltips>
                    {rowData?.isLegal && <img src={star_icon} alt="legal" />}
                    {rowData?.IsFullQC && <img src={check_yellow_icon} alt="QC" />}
                </div>
            </div>
        );
    };

    const dueInTemplate = (rowData) => {
        if (rowData?.isChild) {
            return <></>;
        }
        const dueDate = rowData?.DueDate;
        const formattedDate = moment(dueDate).format('MM/DD/YYYY');
        const formatDiff = () => {
            const diff = getDaysDiff(dueDate);
            if (diff === 0) return 'Today';
            else if (diff > 0) return 'In ' + diff + ' days';
            else if (diff < 0) return Math.abs(diff) + ' days ago';
        };
        return (
            <div
                style={{
                    color: getDaysDiff(dueDate) < 0 ? '#ef3131' : 'unset',
                    fontWeight: getDaysDiff(dueDate) === 0 ? 600 : 400,
                }}
            >
                {formatDiff()} ({formattedDate})
            </div>
        );
    };

    const durationTemplate = (rowData) => {
        if (rowData?.isChild) {
            return <></>;
        }
        return <div>{rowData?.Duration ? rowData?.Duration : '--'}</div>;
    };

    const totalPagesTemplate = (rowData) => {
        if (rowData?.isChild) {
            return <></>;
        }
        return <div>{rowData?.TotalPages ? rowData?.TotalPages : '--'}</div>;
    };

    const cgaTypeTemplate = (rowData) => {
        if (rowData?.isChild) {
            return <></>;
        }
        return <div>{CGAFileType[rowData?.CGAType]}</div>;
    };

    const statusTemplate = (rowData) => {
        const statusColors = {
            Rework: '#b76e00',
            Claimed: '#d92d20',
            ProofReading: '#316ea0',
            Proofreading: '#316ea0',
            Review: '#1a7f5a',
            Failed: '#9b0000',
            Submitted: '#5c6f00',
            InProgress: '#6b32ca',
            Uploaded: '#002855',
            Processing: '#5c4a75',
            Completed: '#47590a',
        };

        const color = statusColors[rowData?.Status];
        return <span style={{ color }}>{rowData?.Status}</span>;
    };

    // Modification table cell
    const bodyTemplates = {
        UserFileName: CGAFileTemplate,
        Status: statusTemplate,
        CGAType: cgaTypeTemplate,
        DueDate: dueInTemplate,
        Duration: durationTemplate,
        TotalPages: totalPagesTemplate,
        Actions: ActionTemplate,
    };

    const selectStyles = {
        control: (base) => ({
            ...base,
            height: '50px',
            minWidth: '200px',
            border: '1px solid #e6e6e6',
            borderRadius: '4px',
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999, // Ensure the dropdown is above the modal
        }),
    };

    return (
        <span>
            <Row>
                <Col className="d-flex align-items-center">
                    <div className="mainTitle">
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <span onClick={() => navigate(ALL_FILE_ROUTE)}>All Files</span> <NavigateNextIcon />
                                CGA Files
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </Col>
                <Col md="auto" className="d-flex align-items-center mb-3 gap-3">
                    <Form className="search-group main-search-group">
                        <Form.Group className="search-group" controlId="exampleForm.ControlInput1">
                            <Form.Control
                                className="border-0"
                                type="text"
                                placeholder="Search"
                                onChange={handleSearch}
                                onKeyDown={(e) => {
                                    if (e.keyCode === 13 || e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}
                                autoComplete="off"
                            />
                            <span>
                                <SearchRoundedIcon />
                            </span>
                        </Form.Group>
                    </Form>
                    <button
                        className="filter-btn cursor-pointer"
                        onClick={handleShowProofReaderCGAFileFilter}
                        style={{ background: 'transparent' }}
                    >
                        <Badge color="primary" variant="dot" invisible={!isFilterApplied}>
                            <TuneRoundedIcon />
                        </Badge>
                    </button>
                </Col>
            </Row>
            <Row>
                <Col xs="12" style={{ marginBottom: 50 }}>
                    <div className="card-widget">
                        <CustomTreeTable
                            tableData={cgaFilesTableData}
                            filteredCustomers={CGAFileListTable ? CGAFileListTable : []}
                            totalRecords={CGAFileNoOfRecords}
                            rowsPerPage={rowsPerPage}
                            sortOrder={sortOrder}
                            sortField={sortField}
                            setRowsPerPage={(value) => dispatch(updateCGAFileStates({ rowsPerPage: value, currentPage: 0 }))}
                            handleSortChange={handleSortChange}
                            currentPage={currentPage}
                            setCurrentPage={(value) => dispatch(updateCGAFileStates({ currentPage: value }))}
                            loading={CGAFileLoading}
                            checkbox={false}
                            bodyTemplates={bodyTemplates}
                            pageName="CGA Files"
                        />
                    </div>
                </Col>
            </Row>
            <Modal
                show={proofReaderCGAFileFilterModal}
                onHide={handleCloseProofReaderCGAFileFilter}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName="custom-modal"
            >
                <div>
                    <div className="preview-dropdown-header">
                        Filter By
                        <HighlightOffRoundedIcon
                            onClick={handleCloseProofReaderCGAFileFilter}
                            className="cursor-pointer opacity-50"
                            style={{ height: '28px', width: '28px' }}
                        />
                    </div>
                    <div className="preview-dropdown-body">
                        <Row>
                            <Col md="6" className="mb-3">
                                <label>Client</label>
                                <Select
                                    value={
                                        filterData?.filterClientData
                                            ? {
                                                value: filterData.filterClientData,
                                                label: cgaClientList.find((option) => option.Id === filterData.filterClientData)?.Name,
                                            }
                                            : { value: '', label: 'Show All' }
                                    }
                                    onChange={(selectedOption) => setFilterData({ ...filterData, filterClientData: selectedOption ? selectedOption.value : '' })}
                                    options={[
                                        { value: '', label: 'Show All' },
                                        ...(cgaClientList.map((option) => ({
                                            value: option.Id,
                                            label: option.Name,
                                        })) || []),
                                    ]}
                                    isSearchable
                                    placeholder="Select Client"
                                    styles={selectStyles}
                                    classNamePrefix="custom-select"
                                    menuPortalTarget={document.body} // Render dropdown outside the modal
                                />
                            </Col>
                            <Col md="6" className="mb-3">
                                <label>Status</label>
                                <MultiSelect
                                    value={filterData?.filterFilesStatusData}
                                    onChange={(e) => setFilterData({ ...filterData, filterFilesStatusData: e.value })}
                                    options={CGAFileStatusOptions}
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder="Select Status"
                                    className="w-full md:w-20rem"
                                    style={{
                                        height: '50px',
                                        transition: 'background-color 0.1s ease',
                                        width: '218px',
                                        zIndex: '1060 !important',
                                    }}
                                />
                            </Col>
                            <Col md="12" className="text-end mt-5">
                                <Button
                                    variant="outline-secondary"
                                    onClick={handleCGAFileFilterClear}
                                    className="me-2"
                                    style={{ height: '45.49px', fontWeight: 600 }}
                                >
                                    Clear Filter
                                </Button>
                                <Button
                                    variant="primary"
                                    onClick={() => {
                                        handleCGAFileFilter();
                                    }}
                                    className="ms-2"
                                    style={{ height: '45.49px', fontWeight: 600 }}
                                >
                                    Filter
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Modal>
        </span>
    );
};

export default CGAFiles;
